import { Toast, PatentService } from 'patsnap-biz';
import psHttp from '@patsnap/common-ps-http';
import _ from 'lodash-es';
import type { Values } from 'vue-i18n';
import { DEFAULT_SELECTION, BATCH_SAVE_FOLDER_LIMIT } from '../const';
import { useDialog } from '../composables/use-dialog';
import type { IServiceProps } from '@/types/batch-save';

const { closeDialog } = useDialog();

export class EurekaPatentService extends PatentService {
    constructor({
        t,
        saveData,
    }: {
        t: (key: string, params?: Values) => string;
        saveData: IServiceProps;
    }) {
        super();
        this.axiosInstance = psHttp;
        this.baseUrl = `${import.meta.env.VITE_WORKSPACE_SERVICE_URI}/workspace/web`;
        this.workspaceProductDomain = import.meta.env.VITE_WORKSPACE_URI;
        this.t = t;
        this.saveData = saveData;
        this.successSaveTipClassName = 'eureka-save-to-workspace-success-toast';
        this.enableRange = _.isEmpty(saveData?.solutionIds);
        this.rangeSelector = {
            ...this.rangeSelector,
            allCounts: _.size(saveData?.solutionIds) || saveData?.total || 0,
        };
    }

    /**
     * 覆盖默认的逻辑
     * eureka默认选择前100条填入
     */
    initFolderSelector() {
        this
            .fetchWorkspaces()
            .then(() => {
                if (!this.folderSelector.response) return;

                const addLimit = BATCH_SAVE_FOLDER_LIMIT;
                const maxPerFolder = _.get(this.folderSelector, 'response.maxPerFolder');

                this.rangeSelector.addLimit = addLimit;
                this.rangeSelector.maxPerFolder = maxPerFolder;
                this.rangeSelector.disabledTypes = [];
                const { maxInputLimit, allCounts, groupCounts } = this.rangeSelector;
                this.rangeSelector.countMax = groupCounts || allCounts;
                this.rangeSelector.selectedType = 'RANGE';

                if (allCounts > maxPerFolder) {
                    this.rangeSelector.selectedType = 'RANGE';
                    this.rangeSelector.disabledTypes = ['ALL'];
                }

                this.rangeSelector.max = Math.min(this.rangeSelector.countMax, maxInputLimit, addLimit);
                this.rangeSelector.to = Math.min(this.rangeSelector.max, DEFAULT_SELECTION);

                this.verifyRange();
            });
    }

    getSubmitApiConfig() {
        return {
            url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/workspace/save-patent`,
            method: 'POST',
            headers: { 'X-API-Version': '1.0' },
        };
    }

    tErrorCode(code: string, params: Values) {
        const key = `${this.errorCodeI18nPrefix}.${code}`;
        const defaultKey = `${this.errorCodeI18nPrefix}.400`;
        return this.t(key) ? this.t(key, params) : this.t(defaultKey);
    }

    generateSubmitSaveToWorkspaceParams(status: { isAll: any; from: any; to: any; counts: any; folderId: any; workspaceId: any; }) {
        const {
            isAll, from, to, counts, folderId, workspaceId,
        } = status

        let params: {
            [propName: string]: any
        } = {
            space_id: workspaceId,
            folder_id: folderId,
        }

        if (_.size(this.saveData.solutionIds)) {
            // TODO 后端需要改接口支持多个保存
            params.patent_ids = this.saveData.solutionIds
            params.patent_count = 1
            params.save_all = false
        } else {
            // 批量保存
            params.save_all = isAll
            params.start = from
            params.end = to
            params.patent_count = counts
        }
        console.log('conditions', this.saveData.conditions)
        if (this.saveData.conditions) {
            params = {
                ...params,
                ...this.saveData.conditions,
            }
        }

        return Promise.resolve(params);
    }

    onToastError({ message }: { message: string }) {
        Toast({
            message,
            type: 'error',
            dangerouslyUseHTMLString: true,
            showClose: true,
        });
    }

    onClose(success: { template: string }) {
        closeDialog();
        if (success) {
            const { template } = success;
            Toast.closeAll();

            Toast({
                type: 'success',
                message: template,
                dangerouslyUseHTMLString: true,
                duration: 5000,
                showClose: true,
            });
        }
    }
}
